import { Box, Button, Container, Text } from '@chakra-ui/react';
import Link from 'next/link';
import { useTranslation } from 'react-i18next';

import ArrowIcon from '@/assets/icons/ic-arrow.svg';

export const PresentationReins = () => {
  const { t } = useTranslation();

  return (
    <Box
      bgImage="linear-gradient(180deg, #B6FFE2 0%, rgba(182, 255, 226, 0.00) 100%)"
      bgRepeat="no-repeat"
      pt={8}
      pb={32}
      textAlign="center"
    >
      <Container maxW="1040px">
        <Text fontFamily="heading" mb={8} fontWeight="bold" fontSize="3xl">
          {t('newEventPage.reinsTitle')}
        </Text>
        <Text mt={4}>{t('newEventPage.reinsDescription.0')}</Text>
        <Text my={4}>{t('newEventPage.reinsDescription.1')}</Text>
        <Text>{t('newEventPage.reinsDescription.2')}</Text>
        <Link href="/contact-us/conferences">
          <Button mt={8} variant="solid" colorScheme="black" alignSelf="flex-start" rightIcon={<ArrowIcon />}>
            {t('newEventPage.getStarted')}
          </Button>
        </Link>
      </Container>
    </Box>
  );
};
